import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
let routes = [];
routes.push(
  {
    path: "/mainpage",
    name: "home",
    component: () => import("./views/Home.vue"),
  },
  {
    path: "/view",
    name: "view",
    component: () => import("./views/view.vue"),
  },
  {
    path: "/displayData",
    name: "displayData",
    component: () => import("./views/viewTable.vue"),
  },
  {
    path: "/statHse",
    name: "statHse",
    component: () => import("./views/statHseTable.vue"),
  }
);
export default new Router({
  base: process.env.BASE_URL,
  routes: routes,
});
